import { render, staticRenderFns } from "./singleVendor.vue?vue&type=template&id=88546b42&scoped=true&"
import script from "./singleVendor.vue?vue&type=script&lang=js&"
export * from "./singleVendor.vue?vue&type=script&lang=js&"
import style0 from "./singleVendor.vue?vue&type=style&index=0&id=88546b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88546b42",
  null
  
)

export default component.exports